import Container from "@/components/Container";
import RecommendedPodcastTile from "@/components/FeedTiles/PodcastTile/RecommendedPodcastTile";
import RecommendedWrapper from "@/components/Recommended/RecommendedWrapper";
import { apiPath } from "@/helpers/apiPath";
import { RecommendedTypes } from "@/helpers/pageHelpers/Common/interface";
import { PodcastTileInterface } from "@/helpers/pageHelpers/Podcast/interface";
import useRequest from "@/helpers/useRequest";

import styles from "../EmptyState.module.scss";

const SuggestedEpisodes = () => {
  const { data: episodes } = useRequest(apiPath.EPISODE_LIST({ perPage: 3 }));

  return (
    <RecommendedWrapper title="Najnowsze" className={styles.heading}>
      <Container className={styles.episodesContainer}>
        {episodes?.items.map(({ object, type }, index) => {
          return (
            type === RecommendedTypes.Episode && (
              <RecommendedPodcastTile
                key={index}
                size="medium"
                className={styles.item}
                {...(object as PodcastTileInterface)}
                publishedAt={undefined}
              />
            )
          );
        })}
      </Container>
    </RecommendedWrapper>
  );
};

export default SuggestedEpisodes;
